import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { statusUsers, pagination } = initStore;

  state.statusUsers = statusUsers;
  state.pagination = pagination;
});

export default reset;
